import React from 'react';
import { Button } from 'react-bootstrap';

interface RowTypes {
  ip?: string;
  phone?: string;
  location: string;
  typeAge: string;
  vlr?: string;
  vlrOperator?: string;
  kndl?: string;
  kndlOperator?: string;
  khln?: string;
  khlnOperator?: string;
  addFields?: string;
  className?: string;
  isShowError?: boolean;
  handleEditItem?: () => void;
  isDisabled?: boolean;
}

const TableRowBlackList = ({
  ip,
  phone,
  location,
  typeAge,
  // vlr,
  // vlrOperator,
  // kndl,
  // kndlOperator,
  // khln,
  // khlnOperator,
  addFields,
  className,
  handleEditItem,
}: RowTypes): JSX.Element => {
  let parsedAddFields: any[] = [];
  if (addFields) {
    try {
      parsedAddFields = JSON.parse(addFields);
    } catch (error) {
      console.error('Failed to parse addFields', error);
    }
  }
  return (
    <tr className={`tr-drag ${className}`}>
      <td>{ip}</td>
      <td>{phone}</td>
      <td>{location}</td>
      <td>{typeAge}</td>
      <td>
        {parsedAddFields.map((value, index) => {
          return (
            <div key={`item-${index}`}>
              <p>
                {value.label}({value.field}): {value.operator === '=' ? '' : value.operator}{' '}
                {value.data}
              </p>
            </div>
          );
        })}
      </td>
      <td>
        <div className="text-end">
          <Button onClick={handleEditItem}>Chỉnh sửa</Button>
        </div>
      </td>
    </tr>
  );
};

export default TableRowBlackList;
